import { useEffect, useState } from 'react';
import { Autocomplete } from "@material-ui/lab";
import { Box, makeStyles, TextField } from '@material-ui/core';
import useCustomerApi, { Customer } from '../../api/CustomerApi.hook';

interface Props {
  defaultCustomerId: number|null
  onCustomerSelected: (customerId: number|null) => void;
}

const useStyles = makeStyles(theme => ({
  autocomplete: {
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    width: 400,
  }
}));

const sortCustomers = (customers: Customer[]) => customers
  .sort((customer, anotherCustomer) => customer.name.localeCompare(anotherCustomer.name));

const CustomerSelection = (props: Props) => {
  const classes = useStyles();
  const customerApi = useCustomerApi();
  const [customers, setCustomers] = useState<Customer[]>([]);

  const handleCustomerSelectionChange = (event: object, customer: Customer|null) => {
    props.onCustomerSelected(customer === null ? null : customer.id);
  };

  const findDefaultSelectedCustomer = () => 
    customers.find(customer => customer.id === props.defaultCustomerId);

  useEffect(() => {
    if (customerApi.ready) {
      customerApi.fetchCustomers()
        .then(customers => setCustomers(sortCustomers(customers)))
        .catch(reason => console.error(`Could not fetch customers: ${reason}`));
    }
  }, [customerApi.ready]);

  return (
    <Box display="flex" flexDirection="row" justifyContent="flex-start">
      { customers.length > 0 && <Autocomplete
          defaultValue={ findDefaultSelectedCustomer() }
          className={classes.autocomplete}
          id="customer-selection"
          options={customers}
          getOptionLabel={(customer) => customer.name}
          renderInput={(params) => <TextField {...params} label="Wybrany klient" />}
          onChange={handleCustomerSelectionChange}
        />
      }
    </Box>
  );
};
export default CustomerSelection;